// extracted by mini-css-extract-plugin
export var banner = "_dp-0";
export var closeButton = "_dp-2";
export var greenCheckmark = "_dp-3";
export var hereLink = "_dp-4";
export var titleIcon = "_dp-1";